import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Lazy loading presentation page sections
import InformationHome from "pages/Servicii/ServiciiSpeciale/CuratenieDupaEvenimente/sections/sections/InformationHome";
import TestimonialsHome from "pages/Homepage/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieDupaEvenimente/sections/sections/HeroSection";
import ArticleContent from "pages/Servicii/ServiciiSpeciale/CuratenieDupaEvenimente/sections/sections/ArticleContent";

function CuratenieDupaEvenimente() {
    return (
        <>
            <Helmet>
                <title>Servicii de curățenie după evenimente</title>
                <meta
                    name="description"
                    content="Asigurăm curățenie după evenimente pentru săli, locații private sau spații comerciale, cu intervenție rapidă și rezultate profesionale."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/curatenie-dupa-petreceri-evenimente/"
                />
                <script type="application/ld+json">
                    {`{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Cât de repede puteți interveni după un eveniment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Depinde de programare, locație și volumul de lucru. În cele mai multe cazuri, echipa poate fi organizată rapid — chiar și în aceeași zi sau a doua zi după eveniment. Cu cât ne contactezi mai devreme, cu atât planificarea este mai simplă și intervenția mai rapidă."
      }
    },
    {
      "@type": "Question",
      "name": "Serviciul este disponibil doar pentru săli de evenimente?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Nu. Intervenim în orice tip de locație: spații private, restaurante, birouri, locații comerciale, showroom-uri sau spații folosite pentru evenimente corporate. Dacă evenimentul a avut loc acolo, putem curăța."
      }
    },
    {
      "@type": "Question",
      "name": "Puteți face curățenie și înainte de eveniment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da. Oferim și curățenie înainte de eveniment, pentru ca spațiul să fie pregătit corespunzător înainte de sosirea invitaților. Acest serviciu se stabilește separat, în funcție de tipul locației și de nevoile specifice. Contactează-ne pentru detalii."
      }
    },
    {
      "@type": "Question",
      "name": "Ce faceți dacă există pete dificile sau murdărie persistentă?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Folosim soluții și echipamente specifice tipului de suprafață și naturii murdăriei. Pentru situații mai complexe — pete adânci, suprafețe degradate, zone cu depuneri persistente — putem recomanda servicii suplimentare adaptate, care rezolvă problema temeinic, nu superficial."
      }
    },
    {
      "@type": "Question",
      "name": "Cum se stabilește prețul pentru curățenia după evenimente?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prețul depinde de suprafață, tipul locației, gradul de murdărie, intervalul disponibil pentru intervenție și eventualele servicii suplimentare. Trimite-ne detaliile și primești o ofertă clară, fără costuri ascunse."
      }
    },
    {
      "@type": "Question",
      "name": "Trebuie să asigur eu produsele sau echipamentele de curățenie?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Nu. Echipa vine cu tot ce este necesar: produse profesionale, echipamente și materiale consumabile. Nu ai nicio obligație suplimentară din partea ta. Detaliile exacte se stabilesc la momentul solicitării ofertei."
      }
    },
    {
      "@type": "Question",
      "name": "Ce include, de regulă, curățenia după un eveniment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Serviciul acoperă colectarea deșeurilor, igienizarea suprafețelor și a punctelor de contact, curățarea grupurilor sanitare, curățarea pardoselilor și intervenția în zonele cele mai solicitate. La nevoie, pot fi adăugate și servicii suplimentare pentru anumite suprafețe sau finisaje."
      }
    },
    {
      "@type": "Question",
      "name": "Serviciul este potrivit și pentru evenimente corporate sau spații comerciale?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da. Intervenim atât după evenimente private, cât și după conferințe, târguri, lansări de produse, evenimente în showroom-uri, restaurante sau orice alt tip de spațiu comercial. Serviciul se adaptează la specificul și cerințele fiecărei locații."
      }
    }
  ]
}`}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
            </Card>
        </>
    );
}

export default CuratenieDupaEvenimente;
